import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { saveAs } from "file-saver";

import DownloadIcon from "@mui/icons-material/Download";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

export default function DataGridContainer({
   data,
   height,
   type,
   teamStandingsVariant,
   disableColumnFilter,
   handleLoadIframe,
   callback,
   preview,
}) {
   let columns;
   let initialState;

   const strixhavenSchoolStandingsGrid =
      type === "teamStandings" && teamStandingsVariant === "strixhavenSchools";

   // Team standings columns (type === 'teamStandings')
   if (type === 'teamStandings') {
      columns = [
         {
            field: "Rank",
            headerName: "Rank",
            editable: false,
            width: 80,
            filterable: false,
         },
         {
            field: "Team",
            headerName: strixhavenSchoolStandingsGrid ? "SCHOOL" : "Team",
            editable: false,
            width: 250,
            filterable: true,
         },
         {
            field: "Win",
            headerName: "Win",
            editable: false,
            width: 100,
            filterable: true,
         },
         {
            field: "Loss",
            headerName: "Loss",
            editable: false,
            width: 100,
            filterable: true,
         },
         {
            field: "Draw",
            headerName: "Draw",
            editable: false,
            width: 100,
            filterable: true,
         },
         {
            field: "WinPercent",
            headerName: "Win %",
            editable: false,
            width: 120,
            filterable: true,
            valueGetter: (params) => params.row.WinPercent ? params.row.WinPercent.toFixed(1) + '%' : '0.0%',
         },
      ];

      initialState = {
         sorting: {
            sortModel: [{ field: "Rank", sort: "asc" }],
         },
      };
   } else {
      // Player standings columns (default)
      columns = [
         {
            field: "Rank",
            headerName: "Rank",
            editable: false,
            width: 80,
            filterable: false,
         },
      {
         field: "LastName",
         headerName: "Last",
         editable: false,
         width: 200,
         filterable: true,
         valueGetter: (params) => params.row.LastName,
      },
      {
         field: "FirstName",
         headerName: "First",
         editable: false,
         width: 200,
         filterable: true,
         valueGetter: (params) => params.row.FirstName,
      },
      {
         field: "COUNTRY",
         headerName: "Country",
         editable: false,
         width: 200,
         filterable: true,
         valueGetter: (params) => params.row.COUNTRY,
         renderCell: (params) => (
            <>
               <img
                  src={params.row.CountryFlag}
                  width='20'
                  style={{ marginRight: "1em" }}
               />
               {params.row.COUNTRY}
            </>
         ),
      },
      {
         field: "MatchWins",
         headerName: "Wins",
         editable: false,
         width: 100,
         filterable: true,
      },
      {
         field: "MatchLosses",
         headerName: "Losses",
         editable: false,
         width: 100,
         filterable: true,
      },
      {
         field: "MatchDraws",
         headerName: "Draws",
         editable: false,
         width: 100,
         filterable: true,
      },
      {
         field: "Points",
         headerName: "Points",
         editable: false,
         width: 100,
         filterable: true,
      },
      {
         field: "Age",
         headerName: "Age",
         editable: false,
         width: 80,
         filterable: true,
         valueGetter: (params) => params.row.Age,
      },
      {
         field: "HOF",
         headerName: "HOF",
         editable: false,
         width: 80,
         filterable: true,
         valueGetter: (params) => params.row.HOF,
      },
      {
         field: "id",
         headerName: "ID",
         editable: false,
         width: 50,
         filterable: false,
      },
      {
         field: "PlayerId",
         headerName: "Player Id",
         editable: false,
         width: 100,
         filterable: false,
         valueGetter: (params) => params.row.PlayerId,
      },
   ];

      initialState = {
         sorting: {
            sortModel: [{ field: "Rank", sort: "asc" }],
         },
         columns: {
            columnVisibilityModel: {
               id: false,
               PlayerId: false,
               TournamentId: false,
               Status: false,
               Tiebreaker1: false,
               Tiebreaker2: false,
               Tiebreaker3: false,
            },
         },
      };
   }

   const handleCallback = (e) => {
      callback(e.target.id, e.target.value);
   };

   const handlePreview = (e) => {
      preview(e.target.id);
   };

   const handleDownload = (e) => {
      saveAs(SERVER_URL + "/cardimages/png/" + e.target.value, e.target.value);
   };

   return (
      <>
         <Box sx={{ height: height ? height : 400, width: "100%" }}>
            <DataGrid
               getRowId={(row) => type === 'teamStandings' ? row.Team : row.id}
               componentsProps={{
                  toolbar: {
                     csvOptions: {
                        fileName: type === 'teamStandings' ? "TeamStandings_" + Date.now() : "PlayerStandings_" + Date.now(),
                     },
                     printOptions: {
                        disableToolbarButton: true,
                     },
                  },
               }}
               initialState={initialState}
               sx={{ backgroundColor: "#efefef" }}
               rows={data}
               rowHeight={
                  type === "cardOverview" || type === "cardOverlay" ? 120 : 40
               }
               disableColumnFilter={disableColumnFilter}
               columns={columns}
               rowsPerPageOptions={[100, 200, 300, 1000, 5000]}
               components={{ Toolbar: GridToolbar }}
               disableSelectionOnClick
            />
         </Box>
      </>
   );
}
